import { HostBuilder } from './builder';

export function createHost<Props extends {}, Env extends object>(
  env: Env,
): HostBuilder<Props, never, Env> {
  return new HostBuilder<Props, never, Env>(env);
}
